module.exports = __webpack_public_path__ + "img/img-4.defaf8d8.png";